import createCategoryAdapter from "./category.adapter";
import createBooksAdapter from "./books.adapter";
import createWikiAdapter from "./wiki.adapter";
import createBoclipsAdapter from "./boclips.adapter";
import createEbscoAdapter from "./ebsco.adapter";
import createAcademiaAdapter from "./academia.adapter";

export const getAdapter = ({ type, searchContext, params, user }) => {
  const { currentSource, currentCategory, currentSubCategory } = searchContext || {};

  const {source, category, academiaSearch} = params;

  const resolvedType =
    source === "books" ? "books" :
    source === "wiki" ? "wiki" :
    category === "boclips" ? "boclips" :
    category === "ebsco" ? "ebsco" :
    academiaSearch ? "academia" :
    type || "category";

  if (resolvedType === "books") return createBooksAdapter({ searchContext });
  if (resolvedType === "wiki") return createWikiAdapter({ searchContext, user });
  if (resolvedType === "boclips") return createBoclipsAdapter({ searchContext });
  if (resolvedType === "ebsco") return createEbscoAdapter({ searchContext });
  if (resolvedType === "academia") return createAcademiaAdapter({ searchContext, params });
  return createCategoryAdapter({ searchContext, params });
};


